(function () {
  'use strict';

  var bar, thumb, btn, sentinel, sectionEl;
  var VISIBLE = 'is-visible';

  function boot() {
    bar = document.getElementById('sticky-atc-bar');
    if (!bar) return;

    var sectionId = bar.dataset.sectionId;
    sectionEl = document.querySelector('[data-section="' + sectionId + '"]');
    if (!sectionEl) return;

    thumb = document.getElementById('sticky-atc-thumb');
    btn   = document.getElementById('sticky-atc-btn');

    setupVisibility(sectionId);
    setupScrollBtn();
    setupThumbSync();
  }
  
  function setupVisibility(sectionId) {
    sentinel =
      sectionEl.querySelector('#buy-buttons-' + sectionId) ||
      sectionEl.querySelector('[id^="buy-buttons"]')        ||
      sectionEl.querySelector('product-form')               ||
      sectionEl.querySelector('.product-form__buttons')     ||
      sectionEl.querySelector('form[action="/cart/add"]');

    if (!sentinel) return;

    var hasBeenSeen = false;
    var footerInView = false;

    var rect = sentinel.getBoundingClientRect();
    var startedInViewport = rect.top < window.innerHeight && rect.bottom > 0;

    if (startedInViewport) {
      hasBeenSeen = true;
    }

    var footer = document.querySelector('footer, .footer, #shopify-section-footer');
    if (footer) {
      new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          var wasFooterInView = footerInView;
          footerInView = e.isIntersecting;
          
          if (footerInView) {
            bar.classList.remove(VISIBLE);
            bar.setAttribute('aria-hidden', 'true');
          } else if (wasFooterInView && !footerInView) {
            var rect = sentinel.getBoundingClientRect();
            var isAboveViewport = rect.bottom < 0;
            
            if (hasBeenSeen && isAboveViewport) {
              bar.classList.add(VISIBLE);
              bar.removeAttribute('aria-hidden');
            }
          }
        });
      }, { threshold: 0.01 }).observe(footer);
    }

    new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) {
          hasBeenSeen = true;
          bar.classList.remove(VISIBLE);
          bar.setAttribute('aria-hidden', 'true');
        } else {
          var rect = sentinel.getBoundingClientRect();
          var isAboveViewport = rect.bottom < 0;
          var isBelowViewport = rect.top > window.innerHeight; 


          if (hasBeenSeen && isAboveViewport && !footerInView) {
            bar.classList.add(VISIBLE);
            bar.removeAttribute('aria-hidden');
          } else {
           
            bar.classList.remove(VISIBLE);
            bar.setAttribute('aria-hidden', 'true');
          }
        }
      });
    }, { threshold: 0.01 }).observe(sentinel);
  }
  
  function setupScrollBtn() {
    if (!btn || !sentinel) return;
    btn.addEventListener('click', function () {
      sentinel.scrollIntoView({ behavior: 'smooth', block: 'center' });
    });
  }

  function setupThumbSync() {
    if (!thumb) return;

    var imgs = Array.from(
      sectionEl.querySelectorAll('img.image-magnify-lightbox')
    );

    if (!imgs.length) return;

    imgs.forEach(function (img) {
      new MutationObserver(function () {
        var src = img.getAttribute('src');
        if (src) setThumb(src);
      }).observe(img, {
        attributes: true,
        attributeFilter: ['src']
      });
    });
  }

  function setThumb(src) {
    if (!src || !thumb) return;

    var url = src.indexOf('//') === 0 ? 'https:' + src : src;

    url = url.indexOf('width=') !== -1
      ? url.replace(/width=\d+/, 'width=120')
      : url + (url.indexOf('?') !== -1 ? '&' : '?') + 'width=120';

    if (thumb.src === url) return;
    thumb.src = url;
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', boot);
}());